import { useRouteHook } from '@shared/hooks';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import type { UserWithPaymentInfo } from '@shared/api/rest/users';
import { ColorsEnum, Icon, Table, TableCellType, Text } from '@shared/widgets';
import LockIcon from '@assets/icons/lock.svg';

const COLUMNS = ['Full name', 'Position', 'accounts', 'Cards'];

interface IUserListViewProps {
  users: UserWithPaymentInfo[];
}

export const UserListView = (props: IUserListViewProps) => {
  const { navigate } = useRouteHook();

  return (
    <Table
      columns={COLUMNS}
      items={props.users.map((user) => {
        return [
          {
            type: TableCellType.Custom,
            value: (
              <div className='flex items-center min-w-0 shrink-0'>
                <div className='w-8 h-8 mr-3 text-base flex flex-none items-center justify-center overflow-hidden rounded-full relative select-none'>
                  <div className='w-full h-full min-w-0 min-h-0 rounded bg-primary flex items-center justify-center relative z-[1]'>
                    <Text weight='medium' size='xl' color={PaletteUtils.getColor(ColorsEnum.Black, ColorsEnum.White)}>
                      {user.firstName?.split('')[0]}
                    </Text>
                  </div>
                  {user.locked && (
                    <div className='absolute left-0 top-0 w-full h-full rounded bg-dark-wet-asphalt z-[3] flex items-center justify-center text-center'>
                      <Icon icon={<LockIcon width='24' height='24' />} color='red' />
                    </div>
                  )}
                </div>
                <div className='py-0.5 px-0 min-w-0 flex-1'>
                  <Text className='overflow-hidden text-ellipsis' size='sm'>
                    {user.firstName} {user.lastName}
                  </Text>
                </div>
              </div>
            ),
          },
          { type: TableCellType.Text, value: user.position },
          { type: TableCellType.Text, value: user.accounts.length },
          { type: TableCellType.Text, value: user.cards.length },
        ];
      })}
      onClick={(rowIndex) => navigate(RoutePaths.user.onNavigate(props.users[rowIndex].id))}
      isScrollable
    />
  );
};
